module.exports = __webpack_public_path__ + "img/p-jkopay.340e43df.svg";